import { IMockHandler } from '@/mock/mock.handler.interface';
import { okList, okSingle } from '@/mock/mock.response.util';
import { CASH_IN_BANK_ACCOUNTS_FIXTURE, DASHBOARD_SUMMARY_FIXTURE } from '@/mock/dashboard/dashboard.fixtures';

/**
 * Mock handler for the dashboard read endpoints (SRP: owns only /dashboard).
 *   GET /dashboard/summary                 -> cards + compare donut
 *   GET /dashboard/cash-in-bank-accounts   -> paginated table
 */
export const dashboardHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }
        return req.url.includes('/dashboard');
    },

    handle(req: any) {
        const { method, url } = req;

        if (method === 'GET' && url.includes('/dashboard/cash-in-bank-accounts')) {
            return okList(CASH_IN_BANK_ACCOUNTS_FIXTURE);
        }

        if (method === 'GET' && url.includes('/dashboard/summary')) {
            return okSingle(DASHBOARD_SUMMARY_FIXTURE);
        }

        throw new Error(`[DashboardHandler] unhandled: ${method} ${url}`);
    }
};
